let denomSelect: HTMLSelectElement | null = null;
let handleChange: (() => void) | null = null;

function updateRuleExamples(selectedDenomination: string): void {
  const ruleSelect = document.querySelector<HTMLSelectElement>('select[name="cash_rounding_rule"]');
  if (!ruleSelect) return;

  const examplesAttr = ruleSelect.getAttribute('data-rule-examples');
  if (!examplesAttr) return;

  try {
    const examples: Record<string, Record<string, string>> = JSON.parse(examplesAttr);
    const denomKey = parseFloat(selectedDenomination).toFixed(2);
    const denomExamples = examples[denomKey];
    if (!denomExamples) return;

    Array.from(ruleSelect.options).forEach((option) => {
      if (denomExamples[option.value]) {
        option.text = denomExamples[option.value];
      }
    });
  } catch (e) {
    // Silently fail if examples can't be parsed
  }
}

function init(): void {
  denomSelect = document.querySelector<HTMLSelectElement>(
    'select[name="cash_rounding_denomination"]'
  );
  if (!denomSelect) return;

  handleChange = () => {
    updateRuleExamples(denomSelect!.value);
  };

  denomSelect.addEventListener('change', handleChange);
}

function cleanup(): void {
  if (denomSelect && handleChange) {
    denomSelect.removeEventListener('change', handleChange);
    denomSelect = null;
    handleChange = null;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

history.onChangeState(
  [
    {
      name: ['admin.views.options'],
      form_name: 'view',
      tab: ['settings'],
    },
  ],
  init,
  cleanup
);
